import { jsx as p } from "react/jsx-runtime";
import a from "clsx";
const c = (t) => a(t), i = "dds-help-text-v0142";
function f({ children: t, className: e = "", disabled: o = !1, id: r, ...s }) {
  const n = {
    [i]: !0,
    [e]: e.length > 0
  };
  return /* @__PURE__ */ p(
    "p",
    {
      className: c(n),
      id: r,
      "aria-disabled": o ? "true" : void 0,
      ...s,
      children: t
    }
  );
}
export {
  f as HelpText
};
//# sourceMappingURL=index.js.map
